// IMPORTANT: Build gql after ANY changes to queries (client OR api)

import { graphql } from '@/client/services/api/graphql/gql';

export const createWorkflowMutation: any = graphql(`
  mutation CreateWorkflow($workflow: WorkflowCreateInput!) {
    createWorkflow(workflow: $workflow) {
      id
      __typename
    }
  }
`);
